const setItem = (key: string, value: string): void => {
   try {
      window.localStorage.setItem(key, value);
   } catch (e) {
      // oh well
   }
};

const getItem = (key: string): string => {
   try {
      return window.localStorage.getItem(key);
   } catch (e) {
      return null;
   }
};

const removeItem = (key: string): void => {
   try {
      window.localStorage.removeItem(key);
   } catch (e) {
      // oh well
   }
};

const getKey = (keyType: string, keyId?: string, userId?: string): string => {
   return [keyType, keyId || 'default', userId].filter(v => v).join('-');
};

export default {
   setItem,
   getItem,
   removeItem,
   getKey
};
